import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Homepage from './Homepage';
import App from './App';
import Portal from './Portal';
import RoofInspection from './RoofInspection';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/crm" element={<App />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/lp/roof-inspection" element={<RoofInspection />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
